import styled, { css } from 'styled-components'
import DatePicker from 'react-datetime-picker'

interface DatePickerWrapperProps {
  disabled?: boolean
  sensitive?: boolean
}
interface DatePickerProps {
  error?: boolean
}

export const DatePickerWrapper = styled.div<DatePickerWrapperProps>`
  ${({ theme, disabled, sensitive }) => css`
    position: relative;
    height: 35px;
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield !important;
    }
    .react-datetime-picker {
      width: 100%;

      .react-datetime-picker__calendar {
        z-index: 10000 !important;
      }

      .react-datetime-picker__wrapper {
        width: 100%;
        border-radius: 3px;
        background-color: ${disabled ? theme.colors.backgroundColor : '#fff'};
        padding-left: 5px;
        border: 1px solid #bdcbd0 !important;
        box-shadow: 0px 2px 12px -5px rgb(0 46 62 / 5%);

        input {
          padding: 3px 6px;
          line-height: 1;
          height: auto;
          -moz-appearance: textfield !important;
        }

        i {
          margin: 0;
          cursor: pointer;
        }
        i.icon-close-x {
          top: 1px;
        }

        .icon-calendar {
          font-size: 1.2em !important;
        }
      }

      .react-datetime-picker__inputGroup__leadingZero {
        display: none !important;
      }

      .react-datetime-picker__calendar-button {
        margin-right: ${sensitive ? '36px' : 0};
      }

      .react-datetime-picker__inputGroup {
        width: 100%;
        padding: 5px;

        span {
          position: relative;
          top: 3px;
          padding: 0 2px;
        }
      }

      abbr[title] {
        text-decoration: none;
        text-transform: capitalize;
        color: ${theme.colors.abyss};
        font-weight: 400;
        font-size: 14px;
      }

      .react-calendar__navigation__label__labelText {
        text-transform: capitalize;
      }

      .react-calendar {
        border: 1px solid #dbe2e4;
        box-shadow: 0px 2px 12px -5px rgb(0 46 62 / 10%);
        margin-top: 4px;
      }

      .react-calendar__viewContainer {
        margin: 12px;
      }

      .react-calendar__navigation button {
        color: ${theme.colors.abyss};
        font-weight: 300;
      }

      .react-calendar__tile--now {
        background: none;
      }

      .react-calendar__tile--active {
        &,
        :hover {
          background: ${theme.primaryColor};
          color: ${theme.secondaryFontColor};
        }
      }

      .react-calendar__tile {
        border-radius: 3px;
        font-weight: 300;
        padding: 15px;
        white-space: nowrap;

        :hover:not(.react-calendar__tile--active) {
          background: ${theme.colors.lightGrey};
        }
      }
    }

    ${theme.mediaQueries.mobile} {
      cursor: pointer;

      .react-calendar {
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        border-radius: 4px !important;
        border: 1px solid #e6e8eb !important;
        box-shadow: 0px 2px 12px -5px rgba(0, 46, 62, 0.1) !important;
      }
    }
  `}
`

export const SensitiveField = styled.div`
  position: relative;
`

export const StyledDatePicker = styled(DatePicker)`
  ${({ error }: DatePickerProps) =>
    error &&
    `
    .react-datetime-picker__wrapper {
      background: #fff6f6 !important;
      border-color: #e0b4b4 !important;
      color: #9f3a38 !important;
    }
`}
`
